<template>
	<div class="space-y-1">
		<label class="block text-sm font-medium text-gray-700">{{ label }}</label>
		<div class="gap-2 flex items-center">
			<button
				v-for="stage in availableStages"
				:key="stage.id"
				@click="updateValue(String(stage.id))"
				class="px-3 py-2 rounded-md cursor-pointer transition-all duration-200 text-sm font-medium outline outline-2 outline-offset-2"
				:class="String(modelValue) === String(stage.id) ? 'outline-black' : 'bg-white text-gray-700 outline-white/0 hover:outline-black/20 hover:bg-gray-50'"
			>
				Stage {{ stage.title }}
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'StageFilter',
	props: {
		modelValue: {
			type: [String, Number],
			default: ''
		},
		availableStages: {
			type: Array,
			required: true
		},
		label: {
			type: String,
			default: 'Stage'
		}
	},
	emits: ['update:modelValue'],
	mounted() {
		// Set the first stage as default if available and no value is set
		if (this.availableStages && this.availableStages.length > 0 && !this.modelValue) {
			this.updateValue(String(this.availableStages[0].id))
		}
	},
	methods: {
		updateValue(value) {
			this.$emit('update:modelValue', value)
		}
	}
}
</script>